/**
 * @module experience/order-summary
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */

export const ORDER_SUMMARY_CONSTANT = {
  ORDER_SUMMARY_MODULE: 'OrderSummaryModule',
  CONFIRM: 'Confirm',
  CONFIRM_CLASS: 'btn btn-primary',
  CONFIRM_TYPE: 'submit',
  LOCKFORCANCEL: 'LOCKFORCANCEL',
  UNLOCK: 'UNLOCK',
  LINE: 'line',
  CANCEL: 'cancel',
  CONSTHEIGHT: '100%',
  POSTVOID: 'postvoid',
  DEVICE: 'Device',
  PLAN: 'Plan',
  SIM_KIT_FEE: 'simKitFee',
  SHIPPING_FEE: 'shippingFee',
  FEE: 'Fee',
  SERVICE: 'Service',
  ON_DEMAND: 'OnDemand',
  ACCESSORY: 'Accessory',
  ITEMSUBCATEGORY: 'itemSubCategory',
  FOUR_DIGIT_ASTRIK: '****',
  RECEIPT: 'RECEIPT',
  TRANSACTION_CONFIRMATION: 'TRANSACTION_CONFIRMATION',
  SERVICE_AGREEMENT_ID: 'SERVICE_AGREEMENT',
  EPIN_CLASSIFICATIONCODE: 'E-PIN',
  MINUS: '-',
  D2A_CLASSIFICATIONCODE: 'Direct to account',
  LOCKFORUPDATE: 'LOCKFORUPDATE',
  SHIP_TO: 'SHIPTO',
  IN_PERSON: 'INPERSON',
  ADD: 'ADD',
  REMOVE: 'REMOVE',
  OTHER: 'OTHER',
  RETURN: 'return',
  EXCHANGE: 'exchange',
  D2A: 'directToAcc',
  EPIN: 'ePin',
  EPIN_RETURN: 'ePinReturn',
  D2A_RETURN: 'd2AReturn',
  EPIN_RETURN_ELIGIBLE: 'isePinReturnEligible',
  D2A_RETURN_ELIGIBLE: 'isd2AReturnEligible',
  EPIN_RETURN_HIDE: 'isePinReturnHideCheckbox',
  D2A_RETURN_HIDE: 'isd2AReturnHideCheckbox',
  EPIN_DATA: 'ePinData',
  D2A_DATA: 'directToAccountData',
  RETURNALL: 'returnAll',
  EXCHANGEALL: 'exchangeAll',
  UNSELECTED: 'unselected',
  SELECTED: 'selected',
  NOT_ALL_SELECTED: 'notAllSelected',
  REFUND_REQUEST_URL: '/refund-request',
  CPS: 'cps',
  SUCCESSCODE: '100',
  REASONCODE: '35',
  ERRORCODE: '102',
  POSID: '1234',
  DEVICE_ASSESSMENT: '/device-assessment',
  FINANCIAL: 'Financial',
  VOUCHER: 'VOUCHER',
  SUB_TOTAL: 'SUBTOTAL',
  SHIPPING: 'SHIPPING',
  TAX_AND_FEE: 'TAX_AND_FEE',
  TOTAL: 'TOTAL',
  BASE: 'BASE',
  APPROVE_OVERRIDE: 'approve_override',
  ADDON: 'ADDON',
  ONDEMAND: 'ONDEMAND',
  ENABLE: 'Enable',
  CHARGE_DOCUMENTS: 'chargeDocuments',
  FINANCIALS: 'FINANCIAL',
  EPINS: 'E-PIN',
  DIRECT_TO_ACCOUNT_REFILL: 'DIRECT TO ACCOUNT REFILL',
  DIRECT_TO_ACCOUNT: 'D2A',
  VOUCHERREFILL: 'VOUCHERREFILL',
  HARD_CARD: 'HARD CARD',
  DEVICES: 'devices',
  PRODUCTOFFERING: 'PRODUCTOFFERING',
  ORDER_CONFIRMATION: '/order-confirmation',
  CONFIRM_BUTTON_TYPE: 'confirm',
  SECONDARY_CLASS: 'btn btn-secondary',
  PRIMARY_CLASS: 'btn btn-primary',
  SUBMIT_BTN: 'submitButton',
  SUBMIT: 'submit',
  HOME: 'home',
  ACCOUNT_LANDING: '/account-landing',
  LINE_DEVICE: 'lineDevice',
  STANDALONE_DEVICE: 'standaloneDevice',
  ORDERSUMMARY_MODULE: 'OrderSummaryModule',
  ORDERSUMMARY_COMPONENTS: 'OrderSummaryComponent',
  OPEN_DOC: 'opendocument://name=workflow&title=search&oamheader=true&url=',
  PAYMENT_STATUS_PROCESSED: 'PROCESSED',
  PAYMENT_STATUS_REFUNDED: 'REFUNDED',
  PAYMENT_STATUS_REVERSED: 'REVERSED',
  RETURN_LABEL_DOCUMENT: 'ReturnLabelDocument',
  ADDRESS_TYPE_SHIPPING: 'SHIPPING',
  WEB: 'web',
  INPROCESS: 'INPROCESS',
  POSTVOIDED: 'POSTVOIDED',
};

export const ORDER_TYPE_CONSTANT = {
  ORDER_SUMMARY: '/order-summary',
  MANAGERATEPLAN: 'MANAGERATEPLAN',
  ADDONORDERTYPE: 'MANAGEADDON',
  CHANGE_PLAN_SERVICE_MODULE: 'CHANGEPLANSERVICE',
  ORDER_MODULE: 'ORDERSUMMARYMODULE',
  ACTIVATION: 'ACTIVATION',
  RETURNORDERTYPE: 'RETURN',
  EXCHANGE: 'EXCHANGE',
  POSTVOID: 'POSTVOID',
  REFUND: 'refund',
  CREDIT: 'CREDIT',
  DEBIT: 'DEBIT',
  PREPAID_BALANCE: 'DEDUCTIONFROMPREPAIDBALANCE',
  ADD: 'ADD',
  REMOVE: 'REMOVE',
  SALESCHANNELCODE_RETAIL: 'RETAIL',
  SALESCHANNELCODE_CARE: 'CARE',
  SALESCHANNELCODE_WEB: 'WEB',
  ADDALINE: 'ADDALINE',
  PURCHASEEQUIPMENT: 'PURCHASEEQUIPMENT',
  CANCELLED: 'CANCELED',
  RETURN_DOCUMENT: 'ReturnLabelDocument',
  CASH: 'CASH',
  VOUCHER: 'VOUCHER',
  PREPAID: 'PREPAID',
  RETAIN: 'RETAIN',
  ADDRESS_TYPE_STORE: 'STORE',
  D2A: 'D2A',
};

export const ORDER_TYPE_SUMMARY_CONSTANT = {
  ORDER_SUMMARY: '/order-summary',
  ACCOUNTUPDATE: 'Account update',
  ACTIVATION: 'Activation',
  ADDALINE: 'Add a line',
  ADDONREDEEM: 'Add on redeem',
  APPLYADJUSTMENTS: 'Apply adjustments',
  BACKOUTPAYMENT: 'Backout payment',
  CHANGEBILLCYCLE: 'Change bill cycle',
  CHANGEDEVICE: 'Change device',
  CHANGEMSISDN: 'Change MSISDN',
  CHANGEOFRESPONSIBILITY: 'Chagne of responsibility',
  CHANGESERVICESTATUS: 'Change service status',
  CHANGESIM: 'Change SIM',
  EXCHANGE: 'Exchange',
  MANAGEADDON: 'Manage add-on',
  MANAGEFEATURE: 'Manage feature',
  MANAGEIMEI: 'Manage IMEI',
  MANAGERATEPLAN: 'Manage rate plan',
  MOVELINEOFSERVICE: 'Move line of service',
  PASSDEPLETION: 'Pass depletion',
  POSTPAYMENT: 'Post payment',
  POSTVOID: 'Post void',
  PURCHASEEQUIPMENT: 'Purchase equipment',
  RECONCILIATION: 'Reconciliation',
  RECURRINGPAYMENT: 'Recurring payment',
  RESENDTOSWITCH: 'Resent to switch',
  RETURN: 'Return',
  REVERSAL: 'Reversal',
  TRANSFERACCOUNTBALANCE: 'Transfer account balance',
  UPDATECUSTOMER: 'Update customer',
  LINE: 'line',
};
export const ORDER_SUMMARY_NUMBER_CONSTANT = {
  OFFSET: -10,
  THREE: 3,
};
